import { isCoreSourceType } from '#pplx/frontend/apps/ask/sources/coreSourcesConfig.js';
export const sortSourcesCoreSourcesToTop = (sources) => {
    return sources.sort((a, b) => {
        const aIsCore = isCoreSourceType(a);
        const bIsCore = isCoreSourceType(b);
        if (aIsCore && !bIsCore) {
            return -1;
        }
        if (!aIsCore && bIsCore) {
            return 1;
        }
        return 0;
    });
};
//# sourceMappingURL=sortSourcesCoreSourcesToTop.js.map